export enum ApiClients {
  properties = 'properties',
  users = 'users',
}
